module.exports = __webpack_public_path__ + "img/why-we-need.1b731de.png";